const text = require('./text.yaml')[templateVars.lang];

/**
 * TODO:
 * 1. Дописать параметры позиционированния нотификаторов
 * 2. Обсудить с Цымпилом текущую реализацию нотификаторов
 *
 */

class Noty {
	constructor() {

	}

	notification(message, title = text.notificationTitle, position = 'fixed', timeout = '3000', callback) {
		if (!message.length) {
			return;
		}

		noty({
			layout: 'inline',
			type: 'notification',
			text: message,
			closeWith: ['click', 'tap'],
			theme: 'noty_container noty_container--fixed',
			template: `<div class="noty_message">
				<span class="noty_title">${title}</span>
				<span class="noty_text"></span>
			</div>`,
			timeout: timeout,
			callback: callback,
		});
	}
}

window.Noty = new Noty();



// WEBPACK FOOTER //
// ./temp/components/notification/index.js